"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InsightSummary = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _ActionDetail = require("../../components/ActionDetails/ActionDetail.styles");

const Wrapper = _styledComponents.default.div`
  padding: ${_blocks.spacing.loose};
  border-bottom: 1px solid ${_blocks.palette.neutral3};
`;

const InsightSummary = ({
  ruleName,
  equipNames
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(_blocks.BodyLarge, {
    style: {
      marginBottom: _blocks.spacing.default
    }
  }, /*#__PURE__*/React.createElement("strong", null, "Insight & Equipments")), /*#__PURE__*/React.createElement(_blocks.BodyLarge, {
    style: {
      marginBottom: _blocks.spacing.tight
    }
  }, ruleName), equipNames.map(equipName => /*#__PURE__*/React.createElement(_ActionDetail.Chip, {
    key: equipName
  }, equipName)));
};

exports.InsightSummary = InsightSummary;